import { render, staticRenderFns } from "./CustomizeMetalZA.vue?vue&type=template&id=2a109460&scoped=true"
import script from "./CustomizeMetalZA.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalZA.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalZA.vue?vue&type=style&index=0&id=2a109460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a109460",
  null
  
)

export default component.exports